import { render, staticRenderFns } from "./OrderSummaryPopup.vue?vue&type=template&id=96c5a0ba&scoped=true&"
import script from "./OrderSummaryPopup.vue?vue&type=script&lang=js&"
export * from "./OrderSummaryPopup.vue?vue&type=script&lang=js&"
import style0 from "./OrderSummaryPopup.vue?vue&type=style&index=0&id=96c5a0ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96c5a0ba",
  null
  
)

export default component.exports